import { IUsuario } from "@/models/usuario.model";
import { createAction, props } from "@ngrx/store";

export const saveUsuarioLogueado = createAction('[Inicio] Save Usuario Logueado', props<{ usuario : IUsuario }>());
export const deleteUsuarioLogueado = createAction('[Logout] Delete Usuario Logueado');
